import React from 'react';
import './Trails.css';
import frontendImg from '../../assets/frontendImg.png';
import dataImg from '../../assets/dataImg.png';
import backendImg from '../../assets/backendImg.png';

function Trails() {
    return (
        <section className='trails'>
            <div className='trails-container'>
                <h1 className='trails-title'>
                    Principais Trilhas
                </h1>
                <div className='trails-container'>
                    <div className='card-trail'>
                        <img className='card-img' src={frontendImg} alt='frontend imagem' />
                        <h1>Trilha Frontend <br />Engineering</h1>
                    </div>
                    <div className='card-trail'>
                        <img className='card-img' src={dataImg} alt='engenharia de dados imagem' />
                        <h1>Data Analysis and <br />Business Data Engineering</h1>
                    </div>
                    <div className='card-trail'>
                        <img className='card-img' src={backendImg} alt='backend imagem' />
                        <h1>Trilha Backend <br />Engineering</h1>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Trails;